export default "__VITE_ASSET__BK_5eqEU__"